import axios from 'axios';

const changePassword = data => axios.put('/user/change-password', data);

export default {
  changePassword,
};
